import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { productCategories } from "../data/mock";

const ProductsGrid = () => {
  return (
    <section
      id="services"
      className="py-24 relative overflow-hidden"
      style={{ backgroundColor: "#f7faf8" }}
    >
      {/* subtle decorative blob */}
      <div
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] rounded-full blur-3xl opacity-[0.06] pointer-events-none"
        style={{
          background:
            "radial-gradient(circle, #10b981 0%, transparent 70%)",
        }}
      />

      <div className="max-w-[1280px] mx-auto px-6 relative">
        {/* Heading */}
        <div className="text-center mb-16 max-w-3xl mx-auto">
          <span
            className="inline-block text-xs font-bold uppercase tracking-[0.25em] mb-4 px-3 py-1 rounded-full bg-emerald-100 text-emerald-700"
          >
            Our Capabilities
          </span>
          <h2
            className="text-3xl md:text-5xl font-bold mb-5 tracking-tight"
            style={{ color: "#0a2e1f" }}
          >
            Design, Engineering & Installation
          </h2>
          <p className="text-slate-600 leading-relaxed">
            Military, Commercial, Industrial Electronic & Electrical Wire &
            Cable — delivered with precision.
          </p>
        </div>

        {/* Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {productCategories.map((product) => (
            <Link
              key={product.id}
              to={`/services/${product.slug}`}
              className="group block bg-white rounded-3xl overflow-hidden border border-slate-100 hover:border-emerald-200 hover:shadow-2xl hover:shadow-emerald-500/10 hover:-translate-y-1 transition-all duration-500"
            >
              <div className="relative aspect-[5/3] overflow-hidden">
                <img
                  src={product.image}
                  alt={product.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0a2e1f]/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                <div className="absolute top-4 right-4 w-10 h-10 rounded-full bg-white/90 backdrop-blur-sm flex items-center justify-center opacity-0 group-hover:opacity-100 translate-y-2 group-hover:translate-y-0 transition-all duration-300">
                  <ArrowUpRight size={18} className="text-emerald-700" />
                </div>
              </div>
              <div className="p-6">
                <h3
                  className="text-lg font-bold mb-2 group-hover:text-emerald-700 transition-colors"
                  style={{ color: "#0a2e1f" }}
                >
                  {product.title}
                </h3>
                <p className="text-slate-600 text-sm leading-relaxed">
                  {product.description}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProductsGrid;
